import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { DynamicLogo } from 'components';

import { fromCompany } from 'store/selectors';
import { setCompany } from '../store/company/actions';
import { AML, StenaLine } from '../store/company/constants';

const GetCompanyFromHostName = (hostname) => {
  const stenaRegex = /stenaline.[a-z]{2,3}/gm;
  const amlRegex = /aml.[a-z]{2,3}/gm;

  if (stenaRegex.test(hostname)) {
    return StenaLine;
  }

  if (amlRegex.test(hostname)) {
    return AML;
  }

  return '';
};

class LogoHandler extends Component {
  componentDidMount() {
    const hostname = window.location.hostname;
    const name = GetCompanyFromHostName(hostname);
    this.props.setCompanyName(name);
  }

  render() {
    const { companyName } = this.props;
    return <DynamicLogo {...{ companyName }} />;
  }
}

LogoHandler.propTypes = {
  companyName: PropTypes.string,
  setCompanyName: PropTypes.func,
};
const mapStateToProps = state => ({
  companyName: fromCompany.getCompanyName(state),
});

const mapDispatchToProps = dispatch => ({
  setCompanyName: name => dispatch(setCompany(name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LogoHandler);



// WEBPACK FOOTER //
// ./src/containers/LogoHandler.js